import { render, staticRenderFns } from "./ChecklistFase1Sidebar.vue?vue&type=template&id=35591044&scoped=true"
import script from "./ChecklistFase1Sidebar.vue?vue&type=script&lang=js"
export * from "./ChecklistFase1Sidebar.vue?vue&type=script&lang=js"
import style0 from "./ChecklistFase1Sidebar.vue?vue&type=style&index=0&id=35591044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35591044",
  null
  
)

export default component.exports